import { InjectionToken } from '@angular/core';
import { DrupalTerm, TranslationItem, Tree } from '@nx-icilalune/drupal-types';
import {
  MainMenuItem,
  MainMenuTreeItem,
  MenuItemContext,
} from '@nx-icilalune/data/icilalune/types';
import { Observable } from 'rxjs';

export const MAIN_MENU = new InjectionToken<Observable<Tree<MainMenuTreeItem>>>(
  'MAIN_MENU'
);

export const SECONDARY_MENU = new InjectionToken<
  Observable<Tree<MainMenuTreeItem>>
>('SECONDARY_MENU');

export const MAIN_MENU_ITEMS = new InjectionToken<
  Observable<Tree<MainMenuItem[]>>
>('MAIN_MENU_ITEMS');

export const CURRENT_MAIN_MENU_ITEM = new InjectionToken<
  Observable<MainMenuItem | undefined>
>('CURRENT_MAIN_MENU_ITEM');

export const CURRENT_MAIN_MENU_TREE_ITEM = new InjectionToken<
  Observable<MainMenuTreeItem>
>('CURRENT_MAIN_MENU_TREE_ITEM');

export const MAIN_MENU_BREADCRUMBS = new InjectionToken<
  Observable<MainMenuItem[]>
>('MAIN_MENU_BREADCRUMBS');

export const COLOR_THEME = new InjectionToken<MenuItemContext | undefined>(
  'COLOR_THEME'
);

export const TERMS_TYPE = new InjectionToken<DrupalTerm[] | undefined>(
  'TERMS_TYPE'
);

export const TERMS_DOMAIN = new InjectionToken<DrupalTerm[] | undefined>(
  'TERMS_DOMAIN'
);

export const TERMS_TECHNOLOGY = new InjectionToken<DrupalTerm[] | undefined>(
  'TERMS_TECHNOLOGY'
);

export const TERMS_BUSINESS_UNIT = new InjectionToken<DrupalTerm[] | undefined>(
  'TERMS_BUSINESS_UNIT'
);

export const ROUTED_ENTITY_ALTERNATIVES = new InjectionToken<TranslationItem[]>(
  'ROUTED_ENTITY_ALTERNATIVES'
);

export const LUNE_MAIN_MENU_ITEM_ACTIVE = new InjectionToken<
  Observable<boolean>
>('LUNE_MAIN_MENU_ITEM_ACTIVE');
